import type { FC } from "react";
import type { ILegendItem, ILegendItems } from "app/components/React/Legends/legendsTypes";
import styled from "styled-components";
import { Legends } from "app/components/React/Legends/Legends";
import { FlexRow, LegendWithOneLineCheckboxFlex } from "@similarweb/ui-components";
import { HeaderContainer, Title } from "app/components/React/legend/vertical-legends-with-search/styled";
import type { LengthArray } from "app/UtilitiesAndConstants/types/lengthArray";

const ChannelsOverviewBarChartLegendWrapper = styled.div`
    float: right;
    width: 235px;
    min-width: 235px;
    height: 100%;
`;

const TitlesContainer = styled(FlexRow)`
    justify-content: space-between;
    margin-bottom: 10px;
`;

interface IChannelsOverviewBarChartLegend {
    legendItems: ILegendItems;
    onLegendsChange: (legendItem: ILegendItem) => void;
    titles?: LengthArray<string, 2>;
}

const ChannelsOverviewBarChartLegend: FC<IChannelsOverviewBarChartLegend> = ({
    legendItems,
    onLegendsChange,
    titles,
}) => {
    return (
        <ChannelsOverviewBarChartLegendWrapper data-automation="channelsOverviewBarChartLegend">
            <HeaderContainer>
                {titles?.length ? (
                    <TitlesContainer>
                        {titles.map((title, index) => (
                            <Title key={index}>{title}</Title>
                        ))}
                    </TitlesContainer>
                ) : null}
            </HeaderContainer>

            <Legends
                legendItems={legendItems}
                toggleSeries={onLegendsChange}
                legendComponent={LegendWithOneLineCheckboxFlex}
                textMaxWidth={"130px"}
                subtitleMaxWidth={"130px"}
                gridDirection="column"
                legendsGap={"8px"}
            />
        </ChannelsOverviewBarChartLegendWrapper>
    );
};

export default ChannelsOverviewBarChartLegend;
